import BigNumber from 'bignumber.js'
import { find } from 'lodash-es'
import { getCurrencyInfo } from '@/utils/localstorage-provider'

export function fen2yuan (num, string) {
  const value = new BigNumber(num)
  if (string) return value.div(100).toString()
  return value.div(100).toNumber()
}

export function yuan2fen (num, string) {
  const value = new BigNumber(num)
  if (string) return value.times(100).toString()
  return value.times(100).toNumber()
}

export function getSymbol (hcurrency) {
  const currencyInfo = getCurrencyInfo().map(item => {
    item.code = item.code?.toLowerCase()
    return item
  })
  return find(currencyInfo, { code: hcurrency?.toLowerCase() })?.symbol || ''
}
